export function initHeroMute() {
    const btn = document.querySelector('.js-hero-mute');
    const iframe = document.querySelector('.js-hero-embed');
    if (!btn || !iframe) return;

    let muted = true;

    btn.addEventListener('click', () => {
        muted = !muted;

        const command = muted ? 'mute' : 'unMute';
        iframe.contentWindow.postMessage(
            JSON.stringify({ event: 'command', func: command, args: [] }),
            '*'
        );

        btn.setAttribute('aria-pressed', String(muted));
    });
}
